var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createSlice } from "@reduxjs/toolkit";
import { fetchProductData, fetchProductDetails, getApiObject, } from "../utils/apiUtils";
import { clone, isEmpty } from "lodash";
export var defaultState = {
    products: getApiObject([]),
    productByIds: getApiObject({}),
};
export var productsReducer = createSlice({
    name: "productlist",
    initialState: defaultState,
    reducers: {
        setProductList: function (state, action) {
            state.products = action.payload;
        },
        setProductsByIds: function (state, action) {
            state.productByIds = action.payload;
        },
    },
});
export var setProductList = (_a = productsReducer.actions, _a.setProductList), setProductsByIds = _a.setProductsByIds;
export var fetchProducts = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var productResponse, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(setProductList(getApiObject([], true)));
                    return [4 /*yield*/, fetchProductData()];
                case 1:
                    productResponse = _a.sent();
                    dispatch(setProductList(getApiObject(productResponse)));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch(setProductList(getApiObject([], false, false, true, error_1 === null || error_1 === void 0 ? void 0 : error_1.message, error_1)));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchProductById = function (id) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var existingProductsIds, latestProductById, existingValues, error_2;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    existingProductsIds = ((_c = (_b = (_a = getState()) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.productByIds) === null || _c === void 0 ? void 0 : _c.data) || {};
                    if (!isEmpty(existingProductsIds === null || existingProductsIds === void 0 ? void 0 : existingProductsIds[id])) {
                        return [2 /*return*/];
                    }
                    dispatch(setProductsByIds(getApiObject(existingProductsIds, true)));
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchProductDetails(id)];
                case 2:
                    latestProductById = _d.sent();
                    existingValues = clone(existingProductsIds);
                    if (!isEmpty(latestProductById)) {
                        existingValues[id] = latestProductById;
                    }
                    dispatch(setProductsByIds(getApiObject(existingValues)));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _d.sent();
                    dispatch(setProductsByIds(getApiObject(existingProductsIds, false, false, true, error_2 === null || error_2 === void 0 ? void 0 : error_2.message, error_2)));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export default productsReducer.reducer;
